import {
  SET_BUYFACTOR,
  SET_BUYS_CHART,
  SET_COSTS_CHART,
  SET_CREDITORS,
  SET_DASHBOARD,
  SET_DASHBOARD_FINANCIALS,
  SET_DEBTORS,
  SET_INCOMES_CHART,
  SET_LATEST_ACCOUNTINGS,
  SET_PAYMENT_CHEQUES,
  SET_PROFIT_AND_LOSS,
  SET_RECIEVE_CHEQUES,
  SET_SALES_CHART,
  SET_SELLFACTOR,
  SET_TOPBUYS,
  SET_TOPSALES,
} from "../../constants/dashboardConstants";

const initialState = {
  dashboard: null,
  debtors: null,
  creditors: null,
  receiveCheques: null,
  paymentCheques: null,
  financials: null,
  topSales: null,
  topBuys: null,
  buyFactor: null,
  sellFactor: null,
  profitAndLoss: null,
  latestAccountings: null,
  buysChart: null,
  salesChart: null,
  incomesChart: null,
  costsChart: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD:
      return {
        ...state,
        dashboard: action.dashboard,
      };
    case SET_DEBTORS:
      return {
        ...state,
        debtors: action.debtors,
      };
    case SET_CREDITORS:
      return {
        ...state,
        creditors: action.creditors,
      };
    case SET_RECIEVE_CHEQUES:
      return {
        ...state,
        receiveCheques: action.receiveCheques,
      };
    case SET_PAYMENT_CHEQUES:
      return {
        ...state,
        paymentCheques: action.paymentCheques,
      };
    case SET_DASHBOARD_FINANCIALS:
      return {
        ...state,
        financials: action.financials,
      };
    case SET_TOPSALES:
      return {
        ...state,
        topSales: action.topSales,
      };
    case SET_TOPBUYS:
      return {
        ...state,
        topBuys: action.topBuys,
      };
    case SET_BUYFACTOR:
      return {
        ...state,
        buyFactor: action.buyFactor,
      };
    case SET_SELLFACTOR:
      return {
        ...state,
        sellFactor: action.sellFactor,
      };
    case SET_PROFIT_AND_LOSS:
      return {
        ...state,
        profitAndLoss: action.profitAndLoss,
      };
    case SET_LATEST_ACCOUNTINGS:
      return {
        ...state,
        latestAccountings: action.latestAccountings,
      };
    case SET_BUYS_CHART:
      return {
        ...state,
        buysChart: action.buysChart,
      };
    case SET_SALES_CHART:
      return {
        ...state,
        salesChart: action.salesChart,
      };
    case SET_INCOMES_CHART:
      return {
        ...state,
        incomesChart: action.incomesChart,
      };
    case SET_COSTS_CHART:
      return {
        ...state,
        costsChart: action.costsChart,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
